import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import SvgIcon from 'vue-svgicon'
// import './icons'   //引入svg-icon

// Vue.use(SvgIcon, {
//   tagName: 'svgicon'
// })

// import Icon from 'vue-svg-icon/Icon.vue';
// Vue.component('icon', Icon);  
// Icon.inject('logo'); // the name of your svg pic


// import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
